import React, { useMemo, useEffect, useState } from "react";
import "./TimeSheet.css";
import "./TsApprove.css";
import DatePicker from "react-datepicker";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { FaCheck, FaTimes } from "react-icons/fa";
import {
  approveTimesheet,
  bulkApproveTimeSheet,
  getPendingTimesheetData,
  sendBackTimesheet,
} from "../../Redux/TimeSheet/Action";
import { format, startOfMonth } from "date-fns";
import Select from "react-select";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Swal from "sweetalert2";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Icon from "../utility/Icon";
const TimesheetApproval = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const { pendingTimesheetList } = useSelector((store) => store.timeSheet);
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(new Date());
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showSendBackModal, setShowSendBackModal] = useState(false);
  const [selectedTimesheetId, setSelectedTimesheetId] = useState(null);
  const [rating, setRating] = useState("");
  const [remarks, setRemarks] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [showApprovalInfo, setShowApprovalInfo] = useState(false);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    dispatch(empList(token, "EMP_SUPPORT"));
  }, [dispatch, token]);

  const options = useMemo(
    () => [
      { value: 0, label: "ALL" }, // Static option
      ...emplists.map((emp) => ({
        value: emp.loginId,
        label: `${emp?.firstName || ""} ${emp?.lastName || ""}`,
      })),
    ],
    [emplists]
  );

  const typeOptions = [
    { value: "N", label: "Pending" },
    { value: "Y", label: "Approved" },
    { value: "B", label: "SendBack" },
  ];

  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  const [selectedType, setSelectedType] = useState(typeOptions[0]);
  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
  };

  useEffect(() => {
    if (selectedEmployee && fromDate && toDate && selectedType) {
      dispatch(
        getPendingTimesheetData(
          selectedEmployee.value,
          formatDate(fromDate),
          formatDate(toDate),
          selectedType.value,
          token,
          pageNumber - 1,
          pageSize
        )
      );
    }
  }, [dispatch, selectedEmployee, fromDate, toDate, selectedType, token, pageNumber, pageSize]);

  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  const handleFromDateChange = (e) => {
    setFromDate(new Date(e.target.value));
  };

  const handleToDateChange = (e) => {
    setToDate(new Date(e.target.value));
  };
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const handleApproveClick = (timesheetId) => {
    const selectedRow = pendingTimesheetList?.pendingList?.find(
      (row) => row.timeSheetId === timesheetId
    );

    setSelectedTimesheet(selectedRow);
    setSelectedTimesheetId(timesheetId);
    setShowApproveModal(true);
  };

  const handleSendBackClick = (timesheetId) => {
    const selectedRow = pendingTimesheetList?.pendingList?.find(
      (row) => row.timeSheetId === timesheetId
    );
    setSelectedTimesheet(selectedRow);
    setSelectedTimesheetId(timesheetId);
    setShowSendBackModal(true);
  };


  // Inside the component
  const [hoverRating, setHoverRating] = useState(0);

  const handleStarClick = (rating) => {
    setRating(rating);
  };

  const handleStarHover = (rating) => {
    setHoverRating(rating);
  };

  const handleStarMouseOut = () => {
    setHoverRating(0);
  };

  //  render the stars dynamically
  const renderStars = () => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          className={`star ${i <= (hoverRating || rating) ? "selected" : ""}`}
          onClick={() => handleStarClick(i)}
          onMouseEnter={() => handleStarHover(i)}
          onMouseLeave={handleStarMouseOut}
          style={{ cursor: "pointer", fontSize: "24px" }}
        >
          &#9733;
        </span>
      );
    }
    return stars;
  };


  const handleCloseApprove = () => {
    setRating("");
    setShowApproveModal(false);
  };

  const handleCloseSendBack = () => {
    setRemarks("");
    setShowSendBackModal(false);
  };

  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    if (rating < 1 || rating > 10) {
      Swal.fire({
        icon: "error",
        title: "Invalid Rating",
        text: "Rating should be between 1 and 10.",
      });
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(approveTimesheet(selectedTimesheetId, rating, token))
        .then(({ success }) => {
          if (success) {
            dispatch(
              getPendingTimesheetData(
                selectedEmployee.value,
                formatDate(fromDate),
                formatDate(toDate),
                selectedType.value,
                token,
                pageNumber - 1,
                pageSize
              )
            );
            handleCloseApprove();
            Swal.fire({
              title: "Success!",
              text: "Timesheet approved successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Timesheet approved unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the timesheet details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleSendBackSubmit = async (e) => {
    e.preventDefault();
    if (!remarks.trim()) {
      Swal.fire({
        title: "Invalid input!",
        text: "Remarks cannot be empty or start with whitespace.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(sendBackTimesheet(selectedTimesheetId, remarks, token))
        .then(({ success }) => {
          if (success) {
            dispatch(
              getPendingTimesheetData(
                selectedEmployee.value,
                formatDate(fromDate),
                formatDate(toDate),
                selectedType.value,
                token,
                pageNumber - 1,
                pageSize
              )
            );
            handleCloseSendBack();
            Swal.fire({
              title: "Success!",
              text: "Timesheet sendback successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Timesheet sendback unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the timesheet details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [

    {
      name: "Start Date",
      selector: (row) => row.startDate || "-",
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => row.endDate || "-",
      sortable: true,
    },

    {
      name: "Name",
      selector: (row) => row.name || "-",
      sortable: true,
    },

    {
      name: "Total",
      selector: (row) => row.totalHours || "-",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      cell: (row) => (
        <div>
          {row.isApproved === "Y" ? (
            <span>Approved</span>
          ) : row.isApproved === "B" ? (
            <span>Sent Back</span>
          ) : (
            <>

              <Icon
                icon={FaCheck}
                variant="success"
                title="Approve"
                onClick={() => handleApproveClick(row.timeSheetId)}
              />

              <Icon
                icon={FaTimes}
                variant="danger"
                title="Reject"
                className="ms-1"           // keep Bootstrap spacing utilities
                onClick={() => handleSendBackClick(row)}
              />

            </>
          )}
        </div>
      ),
    },
  ];

  const bulkApprove = () => {

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve all the time sheets?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) return;

      dispatch(bulkApproveTimeSheet(format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), token))
        .then(({ success, error }) => {
          if (success) {
            dispatch(
              getPendingTimesheetData(
                selectedEmployee.value,
                formatDate(fromDate),
                formatDate(toDate),
                selectedType.value,
                token,
                pageNumber - 1,
                pageSize
              )
            );
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Time sheet approved successfully.",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: error || "Something went wrong. Please try again later.",
            });
          }
        });
    });
  };


  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div>
            <div className="row mb-3 justify-content-end align-items-center">
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">Employee :</label>
                </b>
              </div>
              <div className="col-sm-3">
                <Select
                  options={options}
                  value={selectedEmployee}
                  onChange={handleEmpChange}
                  placeholder="Select Employee"
                  isClearable
                />
              </div>

              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">Type :</label>
                </b>
              </div>
              <div className="col-sm-2">
                <Select
                  options={typeOptions}
                  value={selectedType}
                  onChange={handleTypeChange}
                  placeholder="Select Type"
                  isClearable={false}
                />
              </div>

              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">From Date :</label>
                </b>
              </div>
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <DatePicker
                  selected={fromDate}
                  onChange={(newValue) => {
                    setFromDate(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                />
              </div>

              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <b>
                  <label className="custom-label">To Date :</label>
                </b>
              </div>
              <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <DatePicker
                  selected={toDate}
                  onChange={(newValue) => {
                    setToDate(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                  minDate={fromDate}
                />
              </div>
            </div>
          </div>


          <NewGlobalDataTable
            columns={columns}
            data={pendingTimesheetList.pendingList}
            tableName={'TIMESHEET PENDING LIST'}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            totalRecord={pendingTimesheetList.totalRecord}
          />

          {selectedType?.value === "N" && pendingTimesheetList.totalRecord > 0 &&
            <div className="text-center">
              <button type="button" onClick={bulkApprove} className="btn btn-success mt-3">
                APPROVE ALL
              </button>
            </div>
          }

        </div>
      </div>
      {/* Approval Modal with Rating Field */}
      <div
        className={`modal fade ${showApproveModal ? "show d-block" : ""}`}
        tabIndex="-1"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Approve Timesheet</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseApprove}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleApproveSubmit}>
                <div className="mb-3">
                  <b>
                    <label htmlFor="rating" className="form-label">
                      Rating
                    </label>
                  </b>
                  <div className="stars-container">{renderStars()}</div>
                  {/* <input
                    type="number"
                    className="form-control"
                    id="rating"
                    value={rating}
                    onChange={(e) => setRating(e.target.value)}
                    placeholder="Enter rating"
                    required
                    min="1"
                    max="5"
                  /> */}
                </div>
                {selectedTimesheet && (
                  <div>
                    <p>
                      <b>Name:</b> {selectedTimesheet.name}
                    </p>
                    <p>
                      <b>Date Range:</b> {selectedTimesheet.startDate} to{" "}
                      {selectedTimesheet.endDate}
                    </p>
                    <p>
                      <b>Total Hours:</b> {selectedTimesheet.totalHours}
                    </p>
                  </div>
                )}
                <div className="row">
                  <div className="col text-center mt-3">
                    <button type="submit" className="btn btn-primary">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Send Back Modal with Remarks Field */}
      <div
        className={`modal fade ${showSendBackModal ? "show d-block" : ""}`}
        tabIndex="-1"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Send Back Timesheet</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseSendBack}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSendBackSubmit}>
                <div className="mb-3">
                  <b>
                    <label htmlFor="remarks" className="form-label">
                      Remarks
                    </label>
                  </b>
                  <textarea
                    className="form-control"
                    id="remarks"
                    rows="3"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remarks"
                    required
                  ></textarea>
                </div>
                {selectedTimesheet && (
                  <div>
                    <p>
                      <b>Name:</b> {selectedTimesheet.name}
                    </p>
                    <p>
                      <b>Date Range:</b> {selectedTimesheet.startDate} to{" "}
                      {selectedTimesheet.endDate}
                    </p>
                    <p>
                      <b>Total Hours:</b> {selectedTimesheet.totalHours}
                    </p>
                  </div>
                )}
                <div className="row">
                  <div className="col text-center mt-3">
                    <button type="submit" className="btn btn-primary">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop for modals */}
      {(showApproveModal || showSendBackModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
};

export default TimesheetApproval;
